import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessListRoute: InvariantJiraRoute = {
	name: 'classic-business-list',
	path: '/jira/core/projects/:projectKey/list/:navigationItemId?',
	exact: true,
};
